var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01822 0H7.98178C3.57357 0 0 3.57357 0 7.98178V8.01822C0 12.4264 3.57357 16 7.98178 16H8.01822C12.4264 16 16 12.4264 16 8.01822V7.98178C16 3.57357 12.4264 0 8.01822 0Z",
    fill: "#2B2B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8673 5.78896V7.29966C11.6033 7.27388 11.2602 7.2139 10.8807 7.07488C10.3852 6.89326 10.0164 6.64493 9.77475 6.45266V9.50602L9.76859 9.49649C9.77251 9.55703 9.77475 9.61869 9.77475 9.68091C9.77475 11.1972 8.54096 12.4316 7.02409 12.4316C5.50723 12.4316 4.27344 11.1972 4.27344 9.68091C4.27344 8.1646 5.50723 6.92969 7.02409 6.92969C7.17264 6.92969 7.31839 6.94147 7.46077 6.96445V8.45329C7.32399 8.40452 7.17713 8.37818 7.02409 8.37818C6.30602 8.37818 5.72136 8.96228 5.72136 9.68091C5.72136 10.3995 6.30602 10.9836 7.02409 10.9836C7.74217 10.9836 8.32683 10.399 8.32683 9.68091C8.32683 9.65401 8.32627 9.6271 8.32459 9.60019V3.66669H9.83417C9.83978 3.79449 9.84482 3.92343 9.85043 4.05123C9.86052 4.30292 9.9502 4.54452 10.1066 4.7424C10.2899 4.97503 10.5607 5.24522 10.9407 5.46103C11.2967 5.66227 11.6308 5.74916 11.8673 5.79008V5.78896Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFTiktok);
export default __webpack_public_path__ + "static/media/f-tiktok.9825a118e366100786f10e6e260fac02.svg";
export { ForwardRef as ReactComponent };